<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";
    import { defineProps, withDefaults, toRefs } from "vue";

    const props = withDefaults(
        defineProps<{
            name: string;
            label: string;
        }>(),
        {
            name: "patientlage",
            label: "Patientläge",
        }
    );

    const { name, label } = toRefs(props);

    const fetchPatientlagen = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("operation/patientlage/fetchPatientlagen", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["operation/patientlage/patientlagenSubset"]({ subsetName, displayMode: true });
        } catch (error) {
            console.error("Kunde inte hämta patientlägen:", error);
            flashWarning("Kunde inte hämta patientlägen");
        }
    };
</script>

<template>
    <KAutocomplete
        :name="name"
        :label="label"
        v-bind="$attrs"
        :options="fetchPatientlagen"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
